<template>
  <div>
    <div v-if="!component">
      <top-bar title="Meus Vouchers"/>
    </div>

    <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
    <div v-show="!load">
      <div :class="{'container': !component}">
        <div class="row">
          <div class="col-lg-4" v-for="v in vouchers">
            <div class="card mb-3">
              <div class="card-body">
                <div class="img-fidelidade mb-3">
                  <img :src="v.url_imagem || v.img_produto" :alt="v.titulo" v-if="v.url_imagem || v.img_produto">
                  <img class="img-fidelidade" :src="base_cdn + '/static/imgs/default.png'" v-else>
                </div>
                <div class="mb-3">
                  <h6 class="font-weight-bold mb-0">{{v.titulo}}</h6>
                  <div class="text-muted small">Expira em: {{v.data_expiracao}}</div>
                </div>
                <div class="text-center border-top pt-3">
                  <div class="small" v-if="v.status === '1'">
                    <div class="text-primary font-weight-bolder h4 mb-1">{{v.ref_voucher}}</div>
                    <div>Apresente este código para resgatar o benefício.</div>
                  </div>
                  <div class="font-weight-bold text-muted" v-else>VOUCHER EXPIRADO</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!vouchers.length && !component">
          <div class="text-center" style="padding-top: 43px">
            <i class="fa fa-ticket fa-3x text-primary"></i>
            <h6 class="mt-3 mb-0">Nenhum voucher disponível!</h6>
            <p>Conheça o nosso Programa de Vantagens</p>
            <router-link class="btn btn-outline-primary" :to="url + '/promocoes'">Saiba Mais</router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {TheMask} from 'vue-the-mask';
  import LoginFacebook from '../components/auth/LoginFacebook';
  import Loading from "../components/Loading";
  import CardInfo from "../components/CardInfo";
  import TopBar from "../components/TopBar";

  export default {
    name: 'MeusVouchers',
    components: {TopBar, CardInfo, Loading, TheMask, LoginFacebook},
    props: ['component'],
    data() {
      return {
        token: localStorage.getItem('token'),
        load: true,
        vouchers: [],
      }
    },

    methods: {
      buscarVouchers() {
        this.load = true;
        this.$http.get(this.$store.state.base_url + this.token + '/meus-vouchers')
          .then(response => {
            this.vouchers = response.data;
            this.load = false;

          }, res => {
            this.load = false;
          });
      }
    },

    created() {
      document.body.classList.remove("modal-open");

      if (this.token) {
        this.buscarVouchers();

      } else if (!this.component) {
        this.$router.push(this.url + '/perfil/login');
      }
    },

    mounted() {
      window.scrollTo(0,0);
    },

    computed: {
      url() {
        return this.$store.state.url
      }
    }
  }
</script>

<style scoped>
  .container-pontos {
    height: 65vh;
    overflow: hidden;
  }
  .img-fidelidade img {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 6px;
    display: block;
    background-color: var(--lecard-default);
  }
</style>
